export enum StorageAuthKeys {
    TOKEN = "token",
    REFRESH_TOKEN = "refresh-token",
}
